import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";

const KINDS = [
  { k: "gratitude", label: "Today's gratitude" },
  { k: "sunset", label: "Favourite sunset" },
  { k: "walk", label: "Walk on the beach" },
  { k: "coffee", label: "Coffee together" },
  { k: "kindness", label: "Act of kindness" },
  { k: "custom", label: "Custom" },
];

export default function Moments() {
  const { convId } = useParams();
  const [items, setItems] = useState([]);
  const [kind, setKind] = useState("gratitude");
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const load = async () => {
    try { const { data } = await api.get(`/moments/${convId}`); setItems(data.items || []); }
    catch (e) { setErr(formatApiError(e)); }
  };
  useEffect(() => { load(); }, [convId]);

  const add = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    setBusy(true);
    try { await api.post("/moments", { conversation_id: convId, kind, text }); setText(""); await load(); }
    catch (e) { setErr(formatApiError(e)); }
    finally { setBusy(false); }
  };

  return (
    <div className="max-w-3xl mx-auto space-y-6">
      <Link to={`/app/messages/${convId}`} className="text-sm text-navy/60 hover:text-navy" data-testid="moments-back">← Back to conversation</Link>
      <div>
        <div className="text-xs uppercase tracking-widest text-rose">Wholesome moments</div>
        <h1 className="font-display text-5xl text-navy leading-tight">The little things you share.</h1>
        <p className="text-navy/70 mt-2">Not just messages — sunsets, gratitudes, walks. A gentle timeline of you two.</p>
      </div>

      <form onSubmit={add} className="glass rounded-3xl p-6 space-y-3">
        <div className="flex flex-wrap gap-2">
          {KINDS.map((o) => (
            <button key={o.k} type="button" data-testid={`kind-${o.k}`}
              onClick={() => setKind(o.k)}
              className={`px-3 py-1.5 rounded-full text-sm border transition-all duration-500 ${
                kind === o.k ? "bg-rose text-white border-rose" : "bg-white/70 border-navy/10 text-navy hover:bg-white"
              }`}>{o.label}</button>
          ))}
        </div>
        <textarea data-testid="moments-input" value={text} onChange={(e) => setText(e.target.value)} rows={3}
          placeholder="A small thing worth remembering…"
          className="w-full px-4 py-3 rounded-2xl bg-white/80 border border-navy/10" />
        <div className="flex justify-end">
          <button data-testid="moments-submit" type="submit" disabled={busy || !text.trim()}
            className="btn-pill bg-rose text-white hover:bg-rose-600 disabled:opacity-50">
            {busy ? "Saving..." : "Share moment"}
          </button>
        </div>
      </form>

      <div className="space-y-3">
        {items.map((m) => (
          <div key={m.id} className="glass rounded-2xl p-5" data-testid={`moment-${m.id}`}>
            <div className="text-[11px] uppercase tracking-widest text-rose">{m.kind}</div>
            <div className="text-navy mt-1">{m.text}</div>
            <div className="text-[10px] text-navy/50 mt-2">{new Date(m.at).toLocaleString()}</div>
          </div>
        ))}
        {items.length === 0 && <div className="text-navy/50 text-sm">No moments yet. Share the first small thing.</div>}
      </div>

      {err && <div className="text-sm text-rose-600" data-testid="moments-error">{err}</div>}
    </div>
  );
}
